import React from 'react'
import { NextPage } from 'next'
import PropTypes, { InferProps } from 'prop-types'
import Layout from '../components/Layout'
import { CustomContext, PageProps } from '../types'
import VIP from '../components/VIP'
import '../styles/main.scss'

const vipPropTypes = {
  headerHTML: PropTypes.string.isRequired,
  footerHTML: PropTypes.string.isRequired,
  bootstrapData: PropTypes.shape({
    featureToggles: PropTypes.object,
    partner: PropTypes.object,
    env: PropTypes.string
  }).isRequired
}

type VipProps = InferProps<typeof vipPropTypes>

const Vip: NextPage<VipProps> = ({ headerHTML, footerHTML }) => {
  return (
    <Layout headerHTML={headerHTML} footerHTML={footerHTML}>
      <VIP />
    </Layout>
  )
}

Vip.propTypes = vipPropTypes

Vip.getInitialProps = async (ctx: CustomContext): Promise<PageProps> => {
  const {
    res: { locals }
  } = ctx
  const { content = {}, bootstrapData, bootstrapSETI } = locals
  const { headerHTML = '', footerHTML = '' } = content
  const { partner } = bootstrapData
  if (ctx.res) {
    const vipLandingPageEnabled =
      bootstrapData?.featureToggles?.siteExperience?.vipLandingPageEnabled
    if (vipLandingPageEnabled === false) {
      ctx.res.writeHead(302, { Location: '/' })
      ctx.res.end()
    }
  }

  return {
    headerHTML,
    footerHTML,
    bootstrapData,
    bootstrapSETI,
    partner
  }
}

export default Vip
